export default "__VITE_ASSET__DpZb0cQM__"